import { flatMap } from 'lodash'
import { UploadableAsset } from 'models/Asset'
import { createSelector } from 'reselect'
import { isImage, isVideo } from 'Util/assets'
import { RENDER_FORM_STATE, BEHAVIOUR_FORM_STATE, VIEW_FORM_STATE } from 'config/constants/editorSettings'

export const selectMediaRecordingType = (state: RootState) => state.mainView.showFeatures.mediaRecordingSettings

export const selectPlayerVolume = (state: RootState) => state.mainView.playerVolume as number

export const selectOfflineRestoration = (state: RootState) => state.mainView.offlineRestoration
export const selectMenuItem = createSelector([
  (state: RootState) => state.mainView.menuItem,
], menuItem => menuItem)

export const selectShowSaveSettings = createSelector([
  (state: RootState) => state.mainView.showSaveSettings,
], showSaveSettings => showSaveSettings)

export const selectShowAssetSettingsType = createSelector([
  (state: RootState) => state.mainView.showAssetSettings,
], showAssetSettings => showAssetSettings)

export const selectShowNabletHld = createSelector([
  (state: RootState) => state.mainView.showNabletHldSettings,
], showNabletHldSettings => showNabletHldSettings)

export const selectShowTranscribe = createSelector([
  (state: RootState) => state.mainView.showTranscribeSettings,
], showTranscribeSettings => showTranscribeSettings)

export const selectShowCustomizeView = createSelector([
  (state: RootState) => state.mainView.showCustomizeView,
], showCustomizeView => showCustomizeView)

export const selectShowImportFromUrl = createSelector([
  (state: RootState) => state.mainView.showImportFromUrl,
], showImportFromUrl => showImportFromUrl)

export const selectShowAmazonImport = createSelector([
  (state: RootState) => state.mainView.showAmazonImport,
], showAmazonImport => showAmazonImport)

export const selectActiveDragElement = createSelector([
  state => state.mainView.activeDragElement,
], activeDragElement => activeDragElement)

export const selectShowEditorSettings = createSelector([
  (state: RootState) => state.mainView.showEditorSettings,
], showEditorSettings => showEditorSettings)

export const selectShowReferenceFileChoice = createSelector([
  (state: RootState) => state.mainView.showReferenceFileChoice,
], showReferenceFileChoice => showReferenceFileChoice)

export const selectShowDeleteMediaFilesForm = createSelector([
  (state: RootState) => state.mainView.showDeleteMediaFilesForm,
], showDeleteMediaFilesForm => showDeleteMediaFilesForm)

export const selectShowLogActions = createSelector([
  (state: RootState) => state.mainView.showLogActions,
], showLogActions => showLogActions)

export const selectShowQRCode = createSelector([
  (state: RootState) => state.mainView.showQRCode,
], showQRCode => showQRCode)
export const selectShowInstallComponentMessage = createSelector([
  (state: RootState) => state.mainView.showInstallComponentMessage,
], showInstallComponentMessage => showInstallComponentMessage)

export const selectInstallError = (state: RootState) => state.app.installError

export const selectSelectedSourceMediaFileIds = createSelector([
  (state: RootState) => state.mainView.referenceFilesData,
], referenceFilesData => referenceFilesData.map(file => file.id))

export const selectReferenceFilesData = createSelector([
  (state: RootState) => state.sourceFiles,
  (state: RootState) => state.mainView.referenceFilesData,
], (sourceFiles, referenceFilesData) => {
  const ids = referenceFilesData.map(file => file.id)
  const items = flatMap((Object.values(sourceFiles) as unknown as Array<{ items: UploadableAsset[] }>), x => x?.items)
  const existsIds:Array<string> = []
  return items.filter(x => {
    const isRef = ids.includes(x?.id) && (isVideo(x) || isImage(x))
    if (isRef && !existsIds.includes(x.id)) {
      existsIds.push(x.id)
      return true
    }
    return false
  })
})

// The reducer is JS so TS infers state property types incorrectly — cast once here
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mainView = (state: RootState): Record<string, any> => state.mainView

export const selectRenderSettings = createSelector([
  (state: RootState) => mainView(state).editorRenderSettings as typeof RENDER_FORM_STATE,
], editorRenderSettings => editorRenderSettings)

export const selectBehaviourSettings = createSelector([
  (state: RootState) => mainView(state).editorBehaviourSettings as typeof BEHAVIOUR_FORM_STATE,
], editorBehaviourSettings => editorBehaviourSettings)

export const selectViewSettings = createSelector([
  (state: RootState) => mainView(state).editorViewSettings as typeof VIEW_FORM_STATE,
], editorViewSettings => editorViewSettings)

export const selectDragElementBounds = createSelector([
  state => state.mainView.dragElementBounds,
], dragElementBounds => dragElementBounds as DOMRect)

export const selectBatchImportFilesData = createSelector([
  state => state.mainView.batchImportFiles,
], batchImportFiles => batchImportFiles)

export const selectPendingSelectedAssetId = createSelector([
  state => state.mainView.pendingSelectedAssetId,
], pendingSelectedAssetId => pendingSelectedAssetId)
